export default __webpack_public_path__ + "static/media/project_img_1.4087c47c.jpeg";